// 用户token存储key名
export const userTokenKey = "_hjtm_tk"

// 分页每页条数
export const pageSize = 10

// app调用事件key
export const appEventKey = '_hj_android'

// 已连接设备localStorage Key
export const deviceLocalKey = '_hj_ble_device'

// app下载地址
export const appDownloadUrl = {
  development: 'http://resource.honjoinfo.com:8080/finder?action=share.download&key=cace-adch-0457b692a46c96f309c79b08044fd29d385a17ddedb33fb1e81fc1bed2bfa60c',
  test: 'http://resource.honjoinfo.com:8080/finder?action=share.download&key=cace-adch-0457b692a46c96f309c79b08044fd29d385a17ddedb33fb1e81fc1bed2bfa60c',
  production: 'http://resource.honjoinfo.com:8080/finder?action=share.download&key=cace-adcf-1d737e773d5fbf81193528bc549bc477d9a588daa74165c00fcb8a3c36e9cf74'
}

// 正式环境域名
export const productionHost = 'https://hlms.honjoinfo.com:8096'